export const SURVEY_TYPES: any = {
  1: 'Terceiro',
  2: 'Frota'
}

export const COMPANY_TYPES: any = {
  1: 'Terceiros',
  2: 'Frota'
}

export const EVALUATION_TYPES: any = {
  1: 'Desmobilização',
  2: 'Vistoria de venda',
  3: 'Vistoria de rotina',
  4: 'Vistoria de compra',
  5: 'Vistoria de entrega',
}

export const SURVEY_SITUATIONS: any = {
  1: 'Em cadastramento',
  2: 'Pendente',
  3: 'Iniciada',
  4: 'Aguardando aprovação',
  5: 'Aprovado',
  6: 'Reprovado',
  7: 'Cancelado'
}

export const PREPARATION_SITUATIONS: any = {
  1: 'Em cadastramento',
  2: 'Solicitada',
  3: 'Cancelada',
  4: 'Concluída',
}

export const TYPE_OF_VEHICLES: any = {
  1: 'Leve',
  2: 'Pesado'
}

export const STATUS_VEHICLES: any = {
  1: 'PT',
  2: 'Operacional',
  3: 'Não Operacional'
}

export const EVALUATION_TYPES_INDEX: any = [
  {
    id: 1,
    value: 'Desmobilização'
  },
  {
    id: 2,
    value: 'Vistoria de venda'
  },
  {
    id: 3,
    value: 'Vistoria de rotina'
  },
  {
    id: 4,
    value: 'Vistoria de compra'
  },
  {
    id: 5,
    value: 'Vistoria de entrega'
  },
]

export const inspectionColumnsArr = [
    'Código da vistoria',
    'Versão da vistoria',
    'Placa',
    'Tipo da vistoria',
    'Tipo da avaliação',
    'Categoria da vistoria',
    'Situação vistoria',
    'Tipo de veículo',
    'Modelo',
    'Ano modelo',
    'Contador Atual',
    'Status do Veículo',
    'Proprietário',
    'Diretoria',
    'Número CR',
    'CR Contrato',
    'Empresa avaliadora',
    'Vistoriador',
    'UF',
    'Cidade',
    //'CheckList de Entrega',
    'Usuário solicitante',
    'Data da solicitação',
    'Prazo de Conclusão',
    'Data de Realização Vistoria',
    'Data Aprovação Vistoria',
    'Data última atualização',
    'Usuário última atualização'
  ]